import angular from "angular";

angular
    .module('app')
    .component('dfApplicationForm', {
        template: require('./df-application-form.html'),
        controller: ['$http', '$uibModal', 'Upload', 'moment', controller],
        bindings: {
            stores: '<',
            cars: '<',
            categories: '<',
            application: '<',
        }
    });

function controller($http, $uibModal, Upload, moment) {

    let $ctrl = this;

    $ctrl.store = null;
    $ctrl.car = null;
    $ctrl.selectedCars = [];
    $ctrl.appFiles = [];
    $ctrl.newAppFiles = [];
    $ctrl.totalCost = 0;

    $ctrl.$onInit = function () {
        $ctrl.nowDate = moment().format("DD.MM.YYYY");
        if ($ctrl.application) {
            $ctrl.selectedCars = $ctrl.application.app_cars;
            $ctrl.store = $ctrl.application.store;
            $ctrl.appFiles = $ctrl.application.app_files;
            $ctrl.applicationTotalCost()
        }
    };

    $ctrl.selectCar = function () {
        if (!$ctrl.car) {
            alert('Выберите машину');
            return;
        }

        let exists = $ctrl.selectedCars.find(v => v.car_id === $ctrl.car.id);

        if (exists) {
            alert('Машина уже в списке');
            return;
        }
        let newCar = {
            car_id: $ctrl.car.id,
            number: $ctrl.car.number,
            app_categories: [],
            app_others: [],
            mileage: null,
            old_mileage: $ctrl.car.mileage ? $ctrl.car.mileage.value : null,
        }
        $ctrl.selectedCars.push(newCar);
        $ctrl.car = null;
    }

    $ctrl.addDetail = function (car) {

        $uibModal.open({
            component: 'dfApplicationAddDetail',
            size: 'lg',
            resolve: {
                categories: function () {
                    return $ctrl.categories;
                },
                appCategories: function () {
                    return car.app_categories;
                }
            }
        }).result.then(function (res) {
            let appCategories = car.app_categories;
            let categories = angular.copy($ctrl.categories);

            car.app_categories = [];

            appCategories.forEach(function (category) {

                let newCategory = {
                    id: category.id,
                    name: category.name,
                    old_app_details: category.old_app_details,
                    app_details: [],
                }

                car.app_categories.push(newCategory);

            });

            res.appDetails.forEach(function (detail) {

                if (!detail.amount) {
                    detail.amount = 1;
                    detail.cost = null;
                }

                let ind = car.app_categories.findIndex(v => v.id === detail.category_id);

                if (ind === -1) {
                    let category = categories.find(v => v.id === detail.category_id)
                    car.app_categories.push(category);
                    ind = car.app_categories.length - 1;
                    car.app_categories[ind].app_details = [];
                }
                car.app_categories[ind].app_details.push(detail);
            })

        })

    }

    $ctrl.addOther = function (car) {
        let newOther = {
            name: "",
            amount: 1,
            cost: null,
            mileage: null,
            sent_at: null,
        }
        car.app_others.push(newOther);
    }

    $ctrl.deleteCar = function (index) {
        let per = confirm("Вы точно хотите удалить машину ?");
        if (per) {
            $ctrl.selectedCars.splice(index, 1);
            $ctrl.applicationTotalCost()
        }
    }

    $ctrl.deleteDetail = function (car, categoryIndex, detailIndex, mode) {
        let per = confirm("Вы точно хотите удалить деталь ?");
        if (per) {
            if (mode === 'new') {
                car.app_categories[categoryIndex].app_details.splice(detailIndex, 1);
            } else if (mode === 'old') {
                car.app_categories[categoryIndex].old_app_details.splice(detailIndex, 1);
            }
            if (!car.app_categories[categoryIndex].app_details.length) {
                if (car.app_categories[categoryIndex].old_app_details) {
                    if (!car.app_categories[categoryIndex].old_app_details.length) {
                        car.app_categories.splice(categoryIndex, 1);
                    }
                } else {
                    car.app_categories.splice(categoryIndex, 1);
                }
            }
            $ctrl.applicationTotalCost()
        }
    }

    $ctrl.deleteOther = function (car, index) {
        let per = true;
        if (car.app_others[index].name || car.app_others[index].amount > 1 || car.app_others[index].cost) {
            per = false;
        }
        if (!per) {
            per = confirm("Вы точно хотите удалить деталь ?");
        }
        if (per) {
            car.app_others.splice(index, 1);
            $ctrl.applicationTotalCost()
        }
    }

    $ctrl.deleteFile = function (index, mode) {
        let per = confirm("Вы точно хотите удалить файл ?");
        if (per) {
            if (mode === 2) {
                $ctrl.newAppFiles.splice(index, 1);
            } else if (mode === 1) {
                $ctrl.appFiles.splice(index, 1);
            }
        }
    }

    $ctrl.applicationTotalCost = function () {
        $ctrl.totalCost = 0;
        $ctrl.selectedCars.forEach(function (appCar) {
            appCar.total = 0;
            appCar.app_categories.forEach(function (appCategory) {
                appCategory.app_details.forEach(function (appDetail) {
                    if (typeof appDetail.amount == 'number' && typeof appDetail.cost == 'number') {
                        appDetail.totalCost = appDetail.amount * appDetail.cost;
                        $ctrl.totalCost += appDetail.totalCost;
                        appCar.total += appDetail.totalCost;
                    }
                })
                if (appCategory.old_app_details &&  appCategory.old_app_details.length) {
                    appCategory.old_app_details.forEach(function (appDetail) {
                        if (typeof appDetail.amount == 'number' && typeof appDetail.cost == 'number') {
                            appDetail.totalCost = appDetail.amount * appDetail.cost;
                            $ctrl.totalCost += appDetail.totalCost;
                            appCar.total += appDetail.totalCost;
                        }
                    })
                }
            })
            appCar.app_others.forEach(function (appOther) {
                if (typeof appOther.amount == 'number' && typeof appOther.cost == 'number') {
                    appOther.totalCost = appOther.amount * appOther.cost;
                    $ctrl.totalCost += appOther.totalCost;
                    appCar.total += appOther.totalCost;
                }
            })
        })
    }

    $ctrl.submit = function (action) {
        $ctrl.loading = true;
        let params = {
            action: action,
            appCars: $ctrl.selectedCars,
            storeId: $ctrl.store ? $ctrl.store.id : null,
            comment: $ctrl.comment,
            total: $ctrl.totalCost,
        }
        let url = $ctrl.application ? '/df/applications/' + $ctrl.application.id + '/update' : '/df/applications';
        $http.post(url, params).then(
            function (response) {
                if ($ctrl.appFiles.length || $ctrl.newAppFiles.length) {
                    Upload.upload({
                        url: '/df/applications/' + response.data.application_id + '/files',
                        data: {
                            appFiles: $ctrl.appFiles,
                            newAppFiles: $ctrl.newAppFiles,
                        },
                    }).then(
                        function (res) {
                            window.Swal.fire({
                                icon: 'success',
                                title: response.data.message,
                            }).then(function () {
                                window.location = '/df';
                            })
                        },
                        function (er) {
                            $ctrl.loading = false;
                            window.Swal.fire({
                                icon: 'error',
                                title: 'Не известная ошибка при сохранений, попробуйте еще раз'
                            }).then(function () {
                                window.location = '/df/applications/' + response.data.application_id + '/edit';
                            })
                        }
                    )
                } else {
                    window.Swal.fire({
                        icon: 'success',
                        title: response.data.message,
                    }).then(function () {
                        window.location = '/df';
                    })
                }
            },
            function (error) {
                $ctrl.loading = false;
                let checked = false;
                let message = '';
                angular.forEach(error.data.errors, function (value, key){
                    if (!checked) {
                        message += value[0];
                        checked = true;
                    }
                });
                if (message.length) {
                    window.Swal.fire({
                        icon: 'error',
                        title: message,
                    })
                } else {
                    alert("Не известная ошибка обратитесь к администраций сайта");
                }
            }
        );
    }

    $ctrl.destroy = () => {

        if (!confirm('Вы точно хотите удалить заявку?')) {
            $ctrl.loading = false;
            return;
        }

        const url = '/df/applications/' + $ctrl.application.id + '/destroy';

        $ctrl.loading = true;

        $http
            .post(url)
            .then(
                () => {
                    $ctrl.loading = false;

                    window.Swal.fire({
                        icon: 'success',
                        title: 'Заявка удалена',
                    }).then(() => {
                        window.location = '/df';
                    })
                },
                (error) => {
                    $ctrl.loading = false;

                    window.Swal.fire({
                        icon: 'error',
                        title: error.data.message,
                    });
                }
            );
    }
}
